module.exports = __webpack_public_path__ + "static/media/AHW_02.4c12de03.jpg";